<template>
    <ul class="sidebar-menu">
        <li class="header">MENU DE NAVEGAÇÃO</li>
        <router-link tag="li" class="pageLink" to="/">
            <a>
                <i class="fa fa-desktop"></i>
                <span class="page">Início</span>
            </a>
        </router-link>

        <li class="header" v-if="this.hasPermission(['contrato.read', 'agenda.read', 'relatorio.solicitacao', 'relatorio.escalas', 'relatorio.ofertas', 'relatorio.usuarios'])">ADMINISTRAÇÃO</li>

        <router-link v-if="this.hasPermission('contrato.read')" tag="li" class="pageLink" to="/administracao/contratos">
            <a>
                <i class="fa fa-file-o"></i>
                <span class="page">Contratos</span>
            </a>
        </router-link>

        <router-link v-if="this.hasPermission('agenda.read')" tag="li" class="pageLink" to="/administracao/agendas">
            <a>
                <i class="fa fa-calendar"></i>
                <span class="page">Agenda</span>
            </a>
        </router-link>

        <li class="treeview" v-if="this.hasPermission(['relatorio.solicitacao', 'relatorio.escalas', 'relatorio.ofertas', 'relatorio.usuarios', 'relatorio.agenda.prestador'])">
            <a href="#">
                <i class="fa fa-list"></i>
                <span>Relatórios</span>
                <span class="pull-right-container">
                    <i class="fa fa-angle-left fa-fw pull-right"></i>
                </span>
            </a>
            <ul class="treeview-menu">
                <router-link v-if="this.hasPermission('relatorio.escalas')" tag="li" class="pageLink" to="/administracao/relatorios/escalas">
                    <a>
                        <span class="page">Escalas</span>
                    </a>
                </router-link>

                 <li class="treeview" v-if="this.hasPermission('relatorio.ofertas')">
                    <a href="#">
                        <i class="fa fa-folder-o"></i>
                        <span>Ofertas</span>
                        <span class="pull-right-container">
                            <i class="fa fa-angle-left fa-fw pull-right"></i>
                        </span>
                    </a>
                    <ul class="treeview-menu">
                        <router-link v-if="this.hasPermission('relatorio.ofertas')" tag="li" class="pageLink" to="/administracao/relatorios/ofertas">
                            <a>
                                <span class="page">Procedimentos</span>
                            </a>
                        </router-link>
                        <router-link v-if="this.hasPermission('relatorio.ofertas')" tag="li" class="pageLink" to="/administracao/relatorios/ofertas-anual">
                            <a>
                                <span class="page">Procedimentos (Anual)</span>
                            </a>
                        </router-link>
                         <router-link v-if="this.hasPermission('relatorio.ofertas')" tag="li" class="pageLink" to="/administracao/relatorios/ofertas-subgrupos-anual">
                            <a>
                                <span class="page">Subgrupos (Anual)</span>
                            </a>
                        </router-link>
                    </ul>
                </li>

                <router-link v-if="this.hasPermission('relatorio.usuarios')" tag="li" class="pageLink" to="/administracao/relatorios/usuarios">
                    <a>
                        <span class="page">Relação de Usuários</span>
                    </a>
                </router-link>
                <router-link v-if="this.hasPermission('relatorio.agenda.prestador')" tag="li" class="pageLink" to="/administracao/relatorios/agenda-prestador">
                    <a>
                        <span class="page">Agenda do prestador</span>
                    </a>
                </router-link>
                <router-link v-if="this.$store.state.user.nivel == 'administrador'" tag="li" class="pageLink" to="/administracao/relatorios/consumo-limites">
                    <a>
                        <span class="page">Consumo Limites</span>
                    </a>
                </router-link>
                <li class="treeview" v-if="this.hasPermission('relatorio.solicitacao')">
                    <a href="#">
                        <i class="fa fa-folder-o"></i>
                        <span>Solicitações</span>
                        <span class="pull-right-container">
                            <i class="fa fa-angle-left fa-fw pull-right"></i>
                        </span>
                    </a>
                    <ul class="treeview-menu">
                        <router-link v-if="this.hasPermission('relatorio.solicitacao')" tag="li" class="pageLink" to="/administracao/relatorios/solicitacoes">
                            <a>
                                <span class="page">Analítico</span>
                            </a>
                        </router-link>
                        <router-link v-if="this.hasPermission('relatorio.solicitacao')" tag="li" class="pageLink" to="/administracao/relatorios/solicitacoes-sintetico">
                            <a>
                                <span class="page">Sintético</span>
                            </a>
                        </router-link>
                    </ul>
                </li>
            </ul>
        </li>

        <router-link v-if="this.hasPermission('contrato.write')" tag="li" class="pageLink" to="/administracao/parametros">
            <a>
                <i class="fa fa-tasks"></i>
                <span class="page">Parâmetros Gerais</span>
            </a>
        </router-link>

		<router-link v-if="this.hasPermission('contrato.write')" tag="li" class="pageLink" to="/administracao/comunicados">
			<a>
				<i class="fa fa-comments"></i>
				<span class="page">Comunicados</span>
			</a>
		</router-link>


        <li class="header" v-if="this.hasPermission(['distribuicao.read', 'distribuicao.contrato.read', 'distribuicao.agenda.read'])">DISTRIBUIÇÃO</li>

        <router-link v-if="this.hasPermission('distribuicao.read')" tag="li" class="pageLink" to="/distribuicao/distribuir">
            <a>
                <i class="fa fa-share-alt-square"></i>
                <span class="page">Distribuir</span>
            </a>
        </router-link>

        <router-link v-if="this.hasPermission('distribuicao.contrato.read')" tag="li" class="pageLink" to="/distribuicao/controle-contratos">
            <a>
                <i class="fa fa-share-alt"></i>
                <span class="page">Controle de Contratos</span>
            </a>
        </router-link>

        <router-link v-if="this.hasPermission('distribuicao.agenda.read')" tag="li" class="pageLink" to="/distribuicao/controle-atendimentos">
            <a>
                <i class="fa fa-calendar-check-o"></i>
                <span class="page">Controle da Agenda</span>
            </a>
        </router-link>

        <li class="header" v-if="this.hasPermission(['solicitacao.write', 'solicitacao.read', 'solicitacao.regular', 'solicitacao.atendidoFalta'])">ATENDIMENTOS</li>

        <router-link v-if="this.hasPermission('solicitacao.write')" tag="li" class="pageLink" to="/atendimentos/solicitacao">
            <a>
                <i class="fa fa-calendar-check-o"></i>
                <span class="page">Solicitar</span>
            </a>
        </router-link>

        <router-link v-if="this.hasPermission('solicitacao.read')" tag="li" class="pageLink" to="/atendimentos/verificacao">
            <a>
                <i class="fa fa-search"></i>
                <span class="page">Verificar</span>
            </a>
        </router-link>

        <router-link v-if="this.hasPermission('solicitacao.regular')" tag="li" class="pageLink" to="/atendimentos/regulacao">
            <a>
                <i class="fa fa-stethoscope"></i>
                <span class="page">Regular</span>
            </a>
        </router-link>

        <router-link v-if="this.hasPermission('solicitacao.atendidoFalta')" tag="li" class="pageLink" to="/atendimentos/atendido-falta">
            <a>
                <i class="fa fa-exchange"></i>
                <span class="page">Atendido/Falta</span>
            </a>
        </router-link>

        <li class="header" v-if="this.hasPermission(['paciente.read', 'profissional.read', 'unidade.read', 'grupo.read', 'subgrupo.read', 'forma.organizacao.read', 'procedimento.read'])">CADASTROS</li>

        <router-link v-if="this.hasPermission('paciente.read')" tag="li" class="pageLink" to="/cadastros/pacientes">
            <a>
                <i class="fa fa-user"></i>
                <span class="page">Pacientes</span>
            </a>
        </router-link>

        <router-link v-if="this.hasPermission('profissional.read')" tag="li" class="pageLink" to="/cadastros/profissionais">
            <a>
                <i class="fa fa-user-md"></i>
                <span class="page">Profissionais</span>
            </a>
        </router-link>

        <router-link v-if="this.hasPermission('unidade.read')" tag="li" class="pageLink" to="/cadastros/unidades">
            <a>
                <i class="fa fa-bank"></i>
                <span class="page">Unidades</span>
            </a>
        </router-link>

        <router-link v-if="this.hasPermission('unidade.read')" tag="li" class="pageLink" to="/cadastros/preparos">
            <a>
                <i class="fa fa-bolt"></i>
                <span class="page">Preparos</span>
            </a>
        </router-link>

        <li class="treeview" v-if="this.hasPermission(['grupo.read', 'subgrupo.read', 'forma.organizacao.read', 'procedimento.read'])">
            <a href="#">
                <i class="fa fa-folder"></i>
                <span>Procedimentos</span>
                <span class="pull-right-container">
                    <i class="fa fa-angle-left fa-fw pull-right"></i>
                </span>
            </a>
            <ul class="treeview-menu">
                <router-link v-if="this.hasPermission('grupo.read')" tag="li" class="pageLink" to="/cadastros/grupos-procedimento">
                    <a>
                        <span class="page">Grupos</span>
                    </a>
                </router-link>

                <router-link v-if="this.hasPermission('subgrupo.read')" tag="li" class="pageLink" to="/cadastros/subgrupos-procedimento">
                    <a>
                        <span class="page">Subgrupos</span>
                    </a>
                </router-link>

                <router-link v-if="this.hasPermission('forma.organizacao.read')" tag="li" class="pageLink" to="/cadastros/formas-organizacao-procedimento">
                    <a>
                        <span class="page">Forma de Organização</span>
                    </a>
                </router-link>

                <router-link v-if="this.hasPermission('procedimento.read')" tag="li" class="pageLink" to="/cadastros/procedimentos">
                    <a>
                        <span class="page">Procedimentos</span>
                    </a>
                </router-link>
            </ul>
        </li>

        <router-link v-if="this.hasPermission('usuario.read')" tag="li" class="pageLink" to="/cadastros/usuarios">
            <a>
                <i class="fa fa-users"></i>
                <span class="page">Usuários do Sistema</span>
            </a>
        </router-link>

        <li class="header" v-if="this.hasPermission('paciente-integracao.read')">INTEGRAÇÃO COM O SISTEMA ANTIGO</li>

        <router-link v-if="this.hasPermission('paciente-integracao.read')" tag="li" class="pageLink" to="/integracao/pacientes">
            <a>
                <i class="fa fa-user"></i>
                <span class="page">Pacientes</span>
            </a>
        </router-link>
    </ul>
</template>

<script>
export default {
    name: "SidebarMenu",
    data: () => ({}),
    methods: {}
};
</script>

<style>
/* override default */

.sidebar-menu > li > a {
    padding: 12px 15px 12px 15px;
}

.sidebar-menu li.active > a > .fa-angle-left,
.sidebar-menu li.active > a > .pull-right-container > .fa-angle-left {
    animation-name: rotate;
    animation-duration: 0.2s;
    animation-fill-mode: forwards;
}

@keyframes rotate {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(-90deg);
    }
}
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?17b6ff22